import React from "react";
import DefaultErrorPage from "./default-error-page";
const PageNotFound = () => React.createElement(DefaultErrorPage, null);
export default PageNotFound;
